<template>
    <div class="store-item">
      <p style="margin: 0;margin-bottom: 16px; color: #AD073D" @click="handleClick" class="store-name">{{ data.name }}</p>
      <!-- <p class="store-address">{{ data.address }}<br />{{ data.code }}</p> -->
      <div class="store-address" v-html="data.content"></div>
      <a class="get-directions" v-if="data.link" :href="data.link.url">
        Get Directions <span class="arrows"><svg style="margin: 1px 4px -3px 6px;" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5l7 7l-7 7"/></svg></span>
      </a>
    </div>
  </template>
  
  <script lang="ts" setup>
  interface Store {
  id: number;
  name: string;
  slug: string;
  address: string;
  code: string;
  phone_code: string;
  operating_hours: string;
  tel: string;
  link: any;
  content: string;
}
  interface Props {
  data: Store;
}
  
  import { useI18n } from 'vue-i18n';
  const { locale } = useI18n();
    
  const router = useRouter();
  const props = defineProps<Props>();
  
  const handleClick = () => {
    if(locale.value == 'ms-my'){
      router.push(`/ms-my/locate-us/${props.data.slug}/`);
    }else{
      router.push(`/locate-us/${props.data.slug}/`);
    }
  };
  
  // A placeholder function for directions logic
  const getDirections = () => {
    // console.log("Get Directions button clicked for", props.data.name);
  }
  </script>
  
  <style lang="scss" scoped>

@import "@/assets/scss/components/locate-us/_store-info.scss";

  </style>
  